<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">list_alt</span>
      <p>
        Administra el tarifario de la empresa: los elementos (procedimientos,
        exámenes, medicamentos e insumos) con sus precios, impuestos y fechas
        de vigencia. Estos elementos se usan al registrar el detalle de
        las atenciones médicas.
      </p>
    </div>

    <!-- Cómo funciona -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Cómo funciona
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in flujo" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Campos del formulario -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">edit_note</span>
        Campos del formulario
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in campos" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Impuestos -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">percent</span>
        Impuestos — acceso rápido
      </h3>
      <div class="help-estados">
        <span class="help-estado-badge" style="background:#d4edda;color:#155724">IVA 0%</span>
        <span class="help-estado-badge" style="background:#cce5ff;color:#004085">IVA 12%</span>
        <span class="help-estado-badge" style="background:#d4edda;color:#155724">IVA 15%</span>
      </div>
      <p class="help-card-desc" style="padding:0 0.25rem;margin-top:0.5rem">
        Los tres botones de acceso rápido asignan el impuesto más común
        con un solo clic. También puedes seleccionar cualquier impuesto
        disponible desde el desplegable.
      </p>
    </section>

    <!-- Estados -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">toggle_on</span>
        Estados
      </h3>
      <div class="help-estados">
        <span class="help-estado-badge" style="background:#d4edda;color:#155724">Activo</span>
        <span class="help-estado-badge" style="background:#e2e3e5;color:#383d41">Inactivo</span>
      </div>
      <p class="help-card-desc" style="padding:0 0.25rem;margin-top:0.5rem">
        Solo los elementos <strong>Activos</strong> aparecen disponibles
        al registrar el detalle de una atención. Los elementos
        <strong>Inactivos</strong> conservan su historial pero no pueden
        usarse en nuevas atenciones.
      </p>
    </section>

    <!-- Acciones -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Acciones disponibles
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        El <strong>Nombre</strong> del elemento puede personalizarse para
        adaptarlo a la nomenclatura de la empresa, mientras que el
        <strong>Nombre Estándar</strong> corresponde al catálogo oficial
        del sistema. La <strong>Fecha de Vigencia</strong> indica desde
        cuándo aplica el precio registrado.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaElemEmpr",
  data() {
    return {
      flujo: [
        {
          icon: "table_rows",
          titulo: "Lista del tarifario",
          desc:   "Muestra todos los elementos configurados para la empresa con su nombre, valor, fecha de vigencia y estado.",
        },
        {
          icon: "add_circle",
          titulo: "Nuevo elemento",
          desc:   "Busca el elemento del catálogo estándar, personaliza su nombre y precio, asigna el impuesto y la fecha de vigencia.",
        },
        {
          icon: "edit",
          titulo: "Editar",
          desc:   "Al editar se muestra la clasificación, código y fecha de registro del elemento (solo lectura) además de los campos modificables.",
        },
      ],
      campos: [
        {
          icon: "search",
          titulo: "Nombre Estándar (buscador)",
          desc:   "Escribe parte del nombre del elemento para filtrar el catálogo oficial. Selecciona el elemento deseado de la lista desplegable: se completan automáticamente la clasificación, código y nombre.",
        },
        {
          icon: "label",
          titulo: "Nombre",
          desc:   "Nombre personalizado del elemento para la empresa. Se precarga con el nombre estándar del catálogo y puede modificarse.",
        },
        {
          icon: "percent",
          titulo: "Impuesto",
          desc:   "Tipo de IVA aplicable al elemento. Usa los botones de acceso rápido (IVA 0%, 12%, 15%) o selecciónalo del desplegable.",
        },
        {
          icon: "attach_money",
          titulo: "Valor",
          desc:   "Precio unitario del elemento en el tarifario de la empresa. Este valor se usa como precio por defecto al agregarlo a una atención.",
        },
        {
          icon: "calendar_today",
          titulo: "Fecha de Vigencia",
          desc:   "Fecha desde la cual aplica el precio registrado. Obligatorio.",
        },
        {
          icon: "toggle_on",
          titulo: "Estado",
          desc:   "Activo: disponible para usar en atenciones. Inactivo: oculto en los formularios pero conserva su historial.",
        },
      ],
      acciones: [
        {
          icon:   "add_circle",
          color:  "#0059cc",
          titulo: "Nuevo",
          desc:   "Abre el formulario para agregar un elemento al tarifario de la empresa.",
        },
        {
          icon:   "edit",
          color:  "#198754",
          titulo: "Editar",
          desc:   "Permite modificar el nombre, impuesto, valor, fecha de vigencia y estado del elemento.",
        },
        {
          icon:   "delete",
          color:  "#dc3545",
          titulo: "Eliminar",
          desc:   "Elimina el elemento del tarifario de forma permanente. Si tiene atenciones asociadas, considera desactivarlo en lugar de eliminarlo.",
        },
        {
          icon:   "download",
          color:  "#fd7e14",
          titulo: "Exportar Excel",
          desc:   "Descarga el tarifario completo de la empresa en formato Excel.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>